var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ActionButton",
      class: {
        _small: _vm.small,
        _sub: _vm.sub,
        _selected: _vm.selected,
        _disabled: _vm.disabled
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }